// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"814":"fc63e1bf","2141":"fc63e1bf","4258":"fc63e1bf","4809":"1a9e1c90","5282":"fc63e1bf","8433":"fc63e1bf","8711":"fc63e1bf"}[chunkId] + ".chunk.css";
};